var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompaniesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 28,
    viewBox: "0 0 54 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.00013 12.32C11.4854 12.32 13.5001 10.3142 13.5001 7.83998C13.5001 5.36575 11.4854 3.35999 9.00013 3.35999C6.51484 3.35999 4.50012 5.36575 4.50012 7.83998C4.50012 10.3142 6.51484 12.32 9.00013 12.32Z",
    fill: "#4B9BF5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0075 15.4554C12.735 17.1578 11.25 19.8906 11.25 22.9594V23.5194H1.6875C0.765001 23.5194 0 22.7578 0 21.8394V20.7194C0 17.3146 2.7675 14.5594 6.18751 14.5594H11.8125C12.9825 14.5594 14.085 14.8954 15.0075 15.4554Z",
    fill: "#4B9BF5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0002 12.32C47.4855 12.32 49.5003 10.3142 49.5003 7.83998C49.5003 5.36575 47.4855 3.35999 45.0002 3.35999C42.515 3.35999 40.5002 5.36575 40.5002 7.83998C40.5002 10.3142 42.515 12.32 45.0002 12.32Z",
    fill: "#4B9BF5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M54 20.7194V21.8394C54 22.7578 53.235 23.5194 52.3125 23.5194H42.7499V22.9594C42.7499 19.8906 41.2649 17.1578 38.9924 15.4554C39.9149 14.8954 41.0174 14.5594 42.1874 14.5594H47.8124C51.2324 14.5594 54 17.3146 54 20.7194Z",
    fill: "#4B9BF5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9999 13.44C30.7278 13.44 33.7499 10.4314 33.7499 6.72C33.7499 3.00865 30.7278 0 26.9999 0C23.272 0 20.2499 3.00865 20.2499 6.72C20.2499 10.4314 23.272 13.44 26.9999 13.44Z",
    fill: "#4B9BF5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1878 16.8H20.8128C17.3995 16.8 14.6252 19.5619 14.6252 22.96V26.32C14.6252 27.2474 15.3812 28 16.3127 28H37.6878C38.6193 28 39.3753 27.2474 39.3753 26.32V22.96C39.3753 19.5619 36.601 16.8 33.1878 16.8Z",
    fill: "#4B9BF5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompaniesIcon);
export default __webpack_public_path__ + "static/media/companies-icon.498c379f4e4e0e93919640ef9e2c0214.svg";
export { ForwardRef as ReactComponent };